import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) { toast.error("Email tidak valid"); return; }
    setBusy(true);
    try {
      const r = await api.post("/newsletter/subscribe", { email });
      toast.success(r.data.already_subscribed ? "Anda sudah terdaftar sebelumnya." : "Terima kasih! Anda akan menerima kabar mingguan dari The Reports.");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal berlangganan");
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
      <label className="text-xs uppercase tracking-widest text-[#4B5563] mb-2 inline-flex items-center gap-2">
        <Mail size={12} /> The Reports mingguan
      </label>
      <p className="text-sm text-[#4B5563] mb-3">Satu email seminggu, artikel editorial pilihan untuk orang tua.</p>
      <div className="flex gap-2">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Masukan email Anda"
          data-testid="newsletter-email"
          className="h-10 rounded-full border-[#EAE7E0] bg-white flex-1"
          required
        />
        <Button type="submit" disabled={busy} data-testid="newsletter-submit" className="h-10 px-5 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white">
          {busy ? "…" : "Daftar"}
        </Button>
      </div>
    </form>
  );
}
